import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { accounts } from '../services/api.js';
import './AccountList.css';

function formatDate(dateStr) {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function AccountList() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');

  const loadAccounts = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const params = {};
      if (search.trim()) params.search = search.trim();
      const result = await accounts.list(params);
      const items = result.data || result;
      setData(Array.isArray(items) ? items : []);
    } catch (err) {
      setError(err.message || 'Failed to load accounts');
    } finally {
      setLoading(false);
    }
  }, [search]);

  useEffect(() => {
    loadAccounts();
  }, [loadAccounts]);

  return (
    <div className="al">
      <div className="al__header">
        <div>
          <h1 className="al__title">Accounts</h1>
          <p className="al__subtitle">
            {Array.isArray(data) ? data.length : 0} account
            {!Array.isArray(data) || data.length !== 1 ? 's' : ''}
          </p>
        </div>
        <div className="al__search-wrap">
          <input
            type="text"
            className="al__search"
            placeholder="Search accounts..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      {error && (
        <div className="al__error">
          <p>{error}</p>
          <button className="btn btn--secondary" onClick={loadAccounts}>
            Retry
          </button>
        </div>
      )}

      {loading ? (
        <div className="al__loading">
          <div className="spinner" />
          <p>Loading accounts...</p>
        </div>
      ) : (
        <div className="al__table-wrap card">
          <table className="al__table">
            <thead>
              <tr>
                <th>Insured Name</th>
                <th>Broker ID</th>
                <th>Status</th>
                <th>Created</th>
                <th>Updated</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(data) && data.length > 0 ? (
                data.map((acct) => (
                  <tr
                    key={acct.AccountID}
                    className="al__row"
                    onClick={() => navigate(`/accounts/${acct.AccountID}`)}
                  >
                    <td className="al__name">{acct.InsuredName || '—'}</td>
                    <td>{acct.BrokerID || '—'}</td>
                    <td>
                      <span
                        className={`al__status ${acct.Status === 'active' ? 'al__status--active' : ''}`}
                      >
                        {acct.Status || '—'}
                      </span>
                    </td>
                    <td className="al__date">{formatDate(acct.CreatedAt)}</td>
                    <td className="al__date">{formatDate(acct.UpdatedAt)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="al__empty">
                    No accounts found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
